module.exports = __webpack_public_path__ + "static/media/nike-land-of-new-football-new-football-news-2.0a92bf9d.mp4";